import { p, mb } from '@upgrade/react-components/Spacing/core';
import { Link as URCLink } from '@upgrade/react-components';
import { Link as GatsbyLink } from 'gatsby';
import styled from 'styled-components';

export const ArticleContainer = styled.ul`
  gap: 1rem;
  display: ${({ $bottom }) => ($bottom ? 'flex' : 'none')};
  flex-direction: column;
  ${mb('none')}
  img {
    width: 100%;
    object-fit: cover;
    ${mb('none')};
  }
  li {
    flex: 1 1 0px;
  }
  @media (min-width: ${props => props.theme.mediaSm}) {
    flex-direction: ${({ $bottom }) => ($bottom ? 'row' : 'column')};
    display: flex;
  }
`;

export const ContainerRelatedArticle = styled.div`
  background-color: ${({ theme }) => theme.palette.backgroundSecondary};
  ${p(['xl', 'md', 'none'])};
  display: ${({ $bottom }) => ($bottom ? 'block' : 'none')};
  @media (min-width: ${props => props.theme.mediaSm}) {
    display: block;
  }
`;

export const ImageContainer = styled.div`
  ${({ $imgHeight }) => (!$imgHeight ? 'aspect-ratio: 1.5;' : null)}

  overflow: hidden;
  display: flex;
  ${mb('md')};
  @media (min-width: ${props => props.theme.mediaSm}) {
    height: ${({ $imgHeight }) => $imgHeight ?? 'auto'};
  }
`;

export const ArticleLink = styled(GatsbyLink)`
  display: block;
`;

export const ExternalArticleLink = styled(URCLink)`
  display: block;
`;
